import React from "react";

import { People as PeopleRoute } from "../../../components/People/People";

export const People = () => {
  return <PeopleRoute />;
};
